export default {
    idle: {
        FETCH: 'fetching'
    },
    fetching: {
        FETCHED: 'ready',
        FAILURE: 'idle'
    },
    ready: {
        SEGMENT_CREATE: 'creating',
        SET_ACTIVE: 'reading'
    },
    creating: {
        SEGMENT_COMPLETE: 'completed'
    },
    completed: {
        DURATION_ADJUSTMENT: 'completed',
        SET_ACTIVE: 'reading'
    },
    reading: {
        SET_ACTIVE: 'reading',
        SEGMENT_CUT: 'cutted',
        SEGMENT_DELETE: 'deleted',
        SEGMENT_CREATE: 'creating',
        SEGMENT_UNDO: 'editing',
        SAVE: 'saving'
    },
    editing: {
        SEGMENT_CREATE: 'creating',
        SEGMENT_CUT: 'cutted',
        SEGMENT_DELETE: 'deleted',
        SET_ACTIVE: 'reading',
        SAVE: 'saving'
    },
    cutted: {
        SEGMENT_UNDO: 'editing',
        SEGMENT_CREATE: 'creating',
        SET_ACTIVE: 'reading',
        SAVE: 'saving'
    },
    deleted: {
        SEGMENT_CREATE: 'creating',
        SET_ACTIVE: 'reading',
        SAVE: 'saving'
    },
    saving: {
        FETCH: 'fetching'
    }
};
